import NewsDetail from './news-details';
export default NewsDetail